import Contact from "./contactus/contactus";
import Layout from "../common";

function index() {
  return (
    <Layout>
      <Contact />
    </Layout>
  );
}

export default index;
